module.exports = __webpack_public_path__ + "assets/ab63545d65e36b144f188bd4a07f7b01.mp3";